module.exports = __webpack_public_path__ + "static/media/icon11.d661d95d.svg";